import { useState } from "react";
import type { LaunchpadMetadata } from "../../model/launchpad";

// The Launchpad's logo, as the app shows it in the home screen's toolbar
// (HomeFeature/.../HomeView+Toolbar.swift, principal toolbar item).
//
// iOS sizes the logo to a 12pt height and falls back to the name as a headline
// when there is no logo; this does the same, and also falls back if the image
// is present but fails to load.

/** ToolbarItem(.principal): .frame(height: 12). */
const LOGO_HEIGHT = "h-3";

export interface LaunchpadHeaderProps {
  metadata: LaunchpadMetadata;
}

export default function LaunchpadHeader(props: LaunchpadHeaderProps) {
  const { logoURL, name } = props.metadata.attributes;

  // Tracking the failed URL rather than a boolean means the logo is retried on
  // its own if the Launchpad ever changes.
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const showLogo = logoURL !== null && failedUrl !== logoURL;

  return <header className="flex items-center justify-center px-4">
    {showLogo
      ? <img
          src={logoURL}
          alt={name}
          className={`launchpad-logo ${LOGO_HEIGHT} w-auto max-w-full object-contain`}
          onError={() => setFailedUrl(logoURL)}
        />
      : <p className="truncate text-[17px] font-semibold text-gray-900">
          {name}
        </p>}
  </header>
}
